export const images = {
    flagUk: require('./flag-uk.png'),
    flagVn: require('./flag-vn.png'),
    fbIcon: require('./fb-icon.png'),
    messengerIcon: require('./messenger-icon.png'),
    instaIcon: require('./insta-icon.png'),
    pricing: require('./pricing.jpg'),
    nailService: require('./nail-service.png'),
    nailService2: require('./nail-service2.png'),
    nailService3: require('./nail-service3.png'),
    nailService4: require('./nail-service4.png'),
    leftArrow: require('./left-arrow.png'),
    main_logo:  require('./main-logo.png'),
    header_primary: require('./header_primary.jpg'),
    header_primary02: require('./header_primary02.jpg'),
    banner01: require('./banner01.jpg'),
    banner02: require('./banner02.jpg'),
    banner03: require('./banner03.jpeg'),
    nail01: require('./nail1.jpg'),
    nail02: require('./nail2.png'),
    nail03: require('./nail3.jpg'),
    nail04: require('./nail4.jpg'),
    nail05: require('./nail5.jpg'),
    nail06: require('./nail6.jpg'),
    nail07: require('./nail7.jpg'),
    nail08: require('./nail8.jpg'),
    nail09: require('./nail9.jpg'),
    nail10: require('./nail10.jpg'),
    nail11: require('./nail11.jpg'),
    nail12: require('./nail12.jpg'),
    nail13: require('./nail13.jpeg'),
    nail_shop1: require('./nail_shop1.jpg'),
    nail_shop2: require('./nail_shop2.jpg'),
    nail_shop3: require('./nail_shop3.jpg'),
    nail_shop4: require('./nail_shop4.jpg'),
    nail_shop5: require('./nail_shop5.jpg'),
    nail_shop6: require('./nail_shop6.jpg'),
    discountPoster: require('./discount-poster.png'),
    pedicure: require('./pedicure.jpg'),
    shopName: require('./shop-name.png'),
};
